import QS from 'qs'
import { GET, DELETE, POSTJSON, PUT,Download } from './https'

// 获取后台项目列表
export const getQuestionnaire = (params) => GET(`/api/manager/questionnaire`, params)
// 获取验证码
export const getVerificationCode = (params) => POSTJSON(`/api/manager/account/getVerificationCode?phoneNumber=${params}`)
// 登录
export const login = (params) => POSTJSON(`/api/manager/account/login?${QS.stringify(params)}`)
// 投放
export const launch = (params) => POSTJSON(`/api/manager/questionnaire/launch/${params}`)
// 暂停投放
export const stopLaunch = (params) => POSTJSON(`/api/manager/questionnaire/stopLaunch/${params}`)
// 复制
export const copy = (params) => POSTJSON(`/api/manager/questionnaire/copy/${params}`)
// 获取微信用户列表
export const getUser = (params) => GET('/api/manager/user', params)
// 获取用户的所有参与答题记录
export const getRecords = (params) => GET(`/api/manager/user/${params.id}/records`, params.searchParams)
// 投放属性设置（红包金额/个数/截止时间...）
export const settingApi = (params) => POSTJSON(`/api/manager/questionnaire/setting/${params.id}`, params.settingViewModel, { 'Content-Type': 'application/json-patch+json' })
// 获取参与项目答题用户的记录
export const getLaunchDetail = (params) => GET(`/api/manager/questionnaire/${params.id}/launchDetail`, params.searchParams)
// 获取管理员列表
export const getAdministration = (params) => GET('/api/manager/administration', params)
// 添加管理员
export const addAdministration = (params) => POSTJSON(`/api/manager/administration?${QS.stringify(params)}`)
// 添加管理员
export const addAdministration2 = (params) => POSTJSON(`/api/manager/administration`, params)
export const deleteAdmin = (params) => DELETE(`/api/manager/administration/${params}`)
// 获取管理员列表
export const getTransferRecords = (params) => GET('/api/manager/transferRecords', params)
// 获取后台项目列表
export const getUsual = (params) => GET(`/api/manager/questionnaire/usual`, params)
// 获取结算列表
export const getFinance = (params) => GET(`/api/manager/finance`, params)
// 生成结算
export const settlementPrice = () => GET(`/api/manager/finance/settlementPrice`)
// 汇总
export const getTransferList = (params) => GET(`/api/manager/questionnaire/getTransferList`, params)
//更新充值状态
export const updateRechargeState = (params) => GET(`/api/manager/finance/updateRechargeState/${params}`)
export const getLaunchDetails = (params) => GET(`/api/manager/finance/getLaunchDetails`, params)
export const getShareDetails = (params) => GET(`/api/manager/finance/getShareDetails`, params)
// 获取参与项目答题用户的记录
export const getTags = () => GET(`/api/manager/tags`)
// 获取用户标签
export const getUserTags = (params) => GET(`/api/manager/user/getUserTags?${QS.stringify(params)}`)
export const getMoneyStatistics = () => GET(`/api/MoneyStatistics`)
export const getRechargeRecord = (params) => GET(`/api/RechargeRecord?${QS.stringify(params)}`)
export const addRechargeRecord = (params) => POSTJSON(`/api/RechargeRecord`, params)
export const updateRechargeRecord = (params) => PUT(`/api/RechargeRecord`, params)
 // 下载
export const exportLaunchDetail = (params) => Download(`/api/manager/questionnaire/${params.id}/launchDetail/export`)
// 推广用户登录
export const agentLogin = (params) => POSTJSON(`/api/manager/partner/login?${QS.stringify(params)}`)
// 获取推广用户列表
export const getAgentPage = (params) => GET('/api/manager/partner/page', params)
// 获取推广用户下线列表
export const getAgentChildrenPage = (params) => GET('/api/manager/partner/children', params)
// 获取推广用户下线问卷列表
export const getAgentChildrenQuestionnaire = (params) => GET('/api/manager/partner/children/detail', params)
// 获取推广码
export const getAgentLink = () => GET(`/api/manager/partner/link`)
// 获取推广码
export const refreshLink = (params) => GET(`/api/manager/partner/link/refresh`, params)
// 获取推广员下线所有的答题列表
export const getAgentQuesList = (params) => GET(`/api/manager/partner/children/alldetail`, params)
// 获取所有推广员下线所有的答题列表
export const getAllAgentQuesList = (params) => GET(`/api/manager/partner/allchildren/alldetail`, params)
//设置转账提醒
export const setTransferTip = (params) => GET(`/api/manager/administration/tranfertip`, params)
//设置发展专员
export const setDeveloper = (params) => GET(`/api/manager/administration/developer`, params)
// 获取验证码
export const getSmsCode = (params) => GET(`/api/weixin/panel/sendSMS?mobilePhone=${params}`)
// 获取标签
export const getTagList = (params) => GET(`/api/manager/tag`, params)
// 添加标签
export const addTag = (params) => POSTJSON(`/api/manager/tag`, params)
// 更新标签
export const updateTag = (params) => PUT(`/api/manager/tag`, params)
// 删除标签
export const deleteTag = (id) => DELETE(`/api/manager/tag?id=${id}`)
// 标签模板
export const dowloadTagTemp = (params) => Download(   `/api/manager/tag/download/template`)
// 获取企业列表
export const getEnterprise = (params) => GET(`/api/manager/enterprise/page`, params)
// 获取企业二维码
export const getEnterpriseLink = (params) => GET(`/api/manager/enterprise/link`, params)
// 新增企业
export const addEnterprise = (params) => POSTJSON(`/api/manager/enterprise`, params)
// 更新企业
export const updateEnterprise = (params) => PUT(`/api/manager/enterprise`, params)
// 删除企业
export const delEnterprise = (id) => DELETE(`/api/manager/enterprise?id=${id}`)
// 根据企业id获取企业信息
export const enterpriseInfo = (id) => GET(`/api/manager/enterprise?id=${id}`, { id })
// 新增企业成员
export const addEnterpriseMember = (params) => POSTJSON(`/api/manager/enterprise/member`, params)
// 删除企业成员
export const delEnterpriseMember = (params) => DELETE(`/api/manager/enterprise/member`, params)
// 设置企业成员为负责人
export const setManagerEnterpriseMember = (params) => PUT(`/api/manager/enterprise/member`, params)
// 获取企业合伙人
export const getEnterpriseMember = (params) => GET(`/api/manager/enterprise/member/list`, params)
// 获取企业合伙人详情
export const managerPartner = (params) => GET(`/api/manager/partner`, params)
// 获取企业合伙人下会员详情
export const managerEnterpriseMemberPanelList = (params) => GET(`/api/manager/enterprise/member/panel/list`, params)
// 获取企业详情
export const managerEnterprise = (params) => GET(`/api/manager/enterprise`, params)
// 获取企业下所有会员
export const getPanelList = (params) => GET(`/api/manager/enterprise/panel/list`, params)
// 获取发展专员列表
export const getDevManagerList = (params) => GET(`/api/manager/administration`, params)
// 获取发展专员列表
export const getDevManagerDetail = (params) => GET(`/api/manager/administration/developer/Detail`, params)
// 下载专员月度综合业绩表
export const managerAdministrationDownloadPerformances = `/api/manager/administration/download/performances`
// 下载专员月度业绩表
export const managerAdministrationDownloadPerformance = `/api/manager/administration/download/performance`
// 下载战略合伙人业绩表
export const enterpriseDownloadPerformance = `/api/manager/enterprise/download/performance`
// 下载战略合伙人月度综合业绩表
export const enterpriseDownloadPerformances = `/api/manager/enterprise/download/performances`
// 获取角色权限列表信息
export const rolepermissionpage = (params) => GET(`/api/manager/rolepermission/page`, params)
// 获取所有权限信息
export const rolepermissions = (params) => GET(`/api/manager/rolepermission/permissions`, params)
// 新增角色权限
export const addrolepermissions = (params) => POSTJSON(`/api/manager/rolepermission`, params)
// 更新角色权限
export const updaterolepermissions = (params) => PUT(`/api/manager/rolepermission`, params)
// 给pannel用户添加角色权限
export const rolepermissionpanel = (params) => POSTJSON(`/api/manager/rolepermission/panel`, params)
// 给管理员用户添加角色权限
export const rolepermissionadmin = (params) => POSTJSON(`/api/manager/rolepermission/admin`, params)
// 二级合伙人导出
export const managerenterprisememberexport = `/api/manager/enterprise/member/export`
// 普通用户所有问卷信息导出
export const managerpartnerchildrenalldetailexport = `/api/manager/partner/children/alldetail/export`
// 企业管理员所有问卷信息导出
export const managerpartnerallchildrenalldetailexport = `/api/manager/partner/allchildren/alldetail/export`
// 获取项目交易记录
export const launchDetailList = (params) => GET(`/api/manager/launchDetail/list`, params)
// 获取项目交易记录
export const dowloadLaunchDetailList = (params) => Download(`/api/manager/launchDetail/list/download`, params)
